import { fetchJSON } from '@bonnet/core/fetch';
import { logger } from '@bonnet/core/logger';
import cache from '../cache';
import constants from '../constants';
import getReferenceApiPath from './getReferenceApiPath';
const {
  ATC_INDEXED_LOCATION_FILTERS,
  KBB_INDEXED_LOCATION_FILTERS,
  FORD_INDEXED_LOCATION_FILTERS,
  LOCATION_PRIORITY_HIGH,
  LOCATION_PRIORITY_HIGHEST,
  LOCATION_PRIORITY_ALL
} = constants;
const circuitBreaker = {
  id: 'indexedLocation',
  timeout: 20000,
  fallback: {
    success: false,
    payload: {}
  }
};
export default async function getIndexedLocationFilters() {
  let {
    city,
    state
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let brand = arguments.length > 1 ? arguments[1] : undefined;
  let locationIndexValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : LOCATION_PRIORITY_ALL;
  let response;
  try {
    var _cachedLocationFilter;
    let success = false;
    let payload;
    let message;
    let indexedLocationFilters;
    if (!city && !state) {
      success = false;
      message = 'city and state not provided';
      return {
        success,
        message
      };
    }
    const normalizedCity = city.replace(/[.']/g, '').replace(/\W/g, '-').toLowerCase();
    const normalizedState = state.toLowerCase();
    const cityState = normalizedCity + '-' + normalizedState;
    switch (brand) {
      case 'kbb':
        indexedLocationFilters = KBB_INDEXED_LOCATION_FILTERS;
        break;
      case 'ford':
        indexedLocationFilters = FORD_INDEXED_LOCATION_FILTERS;
        break;
      default:
        indexedLocationFilters = ATC_INDEXED_LOCATION_FILTERS;
    }

    // retrieve cached zip locations
    let cachedLocationFilters = await cache.get(indexedLocationFilters);

    // return cached location filter data if we have it
    if (!cachedLocationFilters) {
      // If location filters is not available from cache then we need to fetch it from the API
      const apiResponse = await fetchJSON(getReferenceApiPath(indexedLocationFilters), {
        circuitBreaker
      });
      if (apiResponse.success) {
        ({
          payload
        } = apiResponse);

        // cache the indexed location zips
        cachedLocationFilters = await cache.put(indexedLocationFilters, payload);
      }
    }

    // look for an indexed location using the state and city.
    const filteredLocation = (_cachedLocationFilter = cachedLocationFilters[normalizedState === null || normalizedState === void 0 ? void 0 : normalizedState.toUpperCase()]) === null || _cachedLocationFilter === void 0 ? void 0 : _cachedLocationFilter[normalizedCity];

    // if a filterdLocation is found in the indexedLocation list, then setup a successful response
    if (filteredLocation) {
      if (locationIndexValue === LOCATION_PRIORITY_ALL || locationIndexValue === LOCATION_PRIORITY_HIGH && (filteredLocation.locationIndexPriority === LOCATION_PRIORITY_HIGHEST || filteredLocation.locationIndexPriority === LOCATION_PRIORITY_HIGH) || locationIndexValue === LOCATION_PRIORITY_HIGHEST && filteredLocation.locationIndexPriority === LOCATION_PRIORITY_HIGHEST) {
        success = true;
        payload = filteredLocation;
      } else {
        success = false;
        message = `cannot find ${cityState} with a priority of at least ${locationIndexValue} value in indexed location`;
      }
    } else {
      success = false;
      message = `cannot find ${cityState} in indexed location`;
    }

    // set the payload and success status on the response
    response = {
      success,
      payload,
      message
    };
  } catch (error) {
    const {
      message
    } = error;
    if (process.env.NODE_ENV === 'development') {
      logger.log(`[@atc/bonnet-reference/getIndexedLocationFilters] ${message}`);
    }
    response = {
      success: false,
      message,
      error
    };
  }
  return response;
}